import { InternalAdvanceStatus, Typenames } from '@varo/graphql-schema-types';
import useAdvanceStatus from 'features/advance/hooks/useAdvanceStatus/useAdvanceStatus';
import { useEffect, useState } from 'react';

export enum AdvanceDestination {
  Registration = 'EmploymentScreen',
  TakeOutAdvance = 'TakeOutAdvance',
  Qualified = 'Qualified',
  NotQualified = 'NotQualified',
  PartiallyQualified = 'PartiallyQualified',
  Active = 'Active',
  Overdue = 'Overdue',
  Processing = 'Processing',
  Banned = 'Banned',
  ManageAccount = 'ManageAccount',
  Unknown = 'Unknown',
}

const useWhereToGo = () => {
  const [status, setStatus] = useState<AdvanceDestination | null>(null);
  const {
    data: { advanceAccount, advanceProductsData, checkingAccount },
    fetching,
    error,
  } = useAdvanceStatus();

  const isAdvanceAccountActive =
    advanceAccount?.advanceStatus === InternalAdvanceStatus.Active;

  const notQualified =
    advanceProductsData?.__typename ===
    Typenames.VaroAdvanceProductsNotQualified;
  const qualifiedProducts =
    advanceProductsData?.__typename === Typenames.VaroAdvanceProductsQualified
      ? advanceProductsData
      : undefined;
  const isFirstTime = qualifiedProducts?.isFirstTime;
  const hasEligibilityRestrictions =
    qualifiedProducts?.hasEligibilityRestrictions;

  useEffect(() => {
    if (advanceAccount) {
      switch (advanceAccount.advanceStatus) {
        case InternalAdvanceStatus.Active:
          setStatus(AdvanceDestination.Active);
          break;
        case InternalAdvanceStatus.PartiallyQualified:
          setStatus(AdvanceDestination.PartiallyQualified);
          break;
        case InternalAdvanceStatus.Qualified:
          setStatus(AdvanceDestination.TakeOutAdvance);
          break;
        case InternalAdvanceStatus.NotQualified:
          setStatus(AdvanceDestination.NotQualified);
          break;
        case InternalAdvanceStatus.Overdue:
          setStatus(AdvanceDestination.Overdue);
          break;
        case InternalAdvanceStatus.Banned:
          setStatus(AdvanceDestination.Banned);
          break;
        case InternalAdvanceStatus.Processing:
          setStatus(AdvanceDestination.Processing);
          break;
        case InternalAdvanceStatus.Undefined:
          setStatus(AdvanceDestination.Unknown);
          break;
      }
    } else if (notQualified && !advanceAccount && checkingAccount) {
      setStatus(AdvanceDestination.NotQualified);
    } else if (isFirstTime) {
      setStatus(AdvanceDestination.Registration);
    } else if (isAdvanceAccountActive) {
      setStatus(AdvanceDestination.Active);
    }
  }, [
    advanceAccount,
    advanceAccount?.advanceStatus,
    advanceAccount?.id,
    advanceAccount?.status,
    checkingAccount,
    isAdvanceAccountActive,
    isFirstTime,
    notQualified,
  ]);

  return {
    status,
    advanceAccount,
    advanceProducts: advanceProductsData,
    checkingAccount,
    fetching,
    error,
    hasEligibilityRestrictions,
  };
};

export default useWhereToGo;
